<template>
  <div class="radio-options step" :class="{active: active, selected: selected, unlocked: unlocked}">
    <div class="step-header" @click="setActive">
      <div class="title">{{optionGroup.name}}</div>
      <div class="value secondary-font" v-if="selected">{{selectedOptions[optionGroup.code].name}}</div>
      <icon-check />
    </div><!-- /.step-header -->
    <div class="step-body" v-if="active">
      <p v-show="sizeWarn" class="red label size-warning">
        <font-awesome-icon icon="exclamation-triangle" class="warning-icon"></font-awesome-icon>Edits will be lost if another size is selected
      </p><!-- /.label -->

      <div class="description-wrapper" v-if="optionGroup.description">
        <p class="description secondary-font small">{{optionGroup.description}}</p>
      </div><!-- /.description-wrapper -->

      <div class="flex-container is-vertical">
        <div
          class="row secondary-font"
          v-for="option in optionGroup.options"
          :key="`option_${option.optionCode}`"
          :class="{disabled: option.isSize && !option.isValid}"
          :id="`radio-${option.optionCode}`"
          @click="selectOption(option)"
        >
          <div class="column">
            <div
              class="radio-button"
              :id="option.optionCode"
              :class="{disabled: option.isSize && !option.isValid, selected: selectedOptions[optionGroup.code].optionCode == option.optionCode}"
            ></div><!-- /.radio-button -->
            <label class="label" :for="option.optionCode">{{option.name}}</label><!-- /.label -->
            <label
              class="blue label"
              :for="option.optionCode"
              v-if="option.price > 0"
            >${{option.price}}</label><!-- /.label -->
            <label
              :for="option.optionCode"
              v-show="option.listPrice > 0 && option.listPrice > option.price"
              class="strikethrough-price label"
            >${{option.listPrice}}</label><!-- /.label -->

            <popper
              root-class="label"
              v-if="option.isSize && option.isLowRes"
            >
              <div
                ref="popper"
                class="popper"
              >
                Please note, we've identified your image as a low quality image for this size. You can continue to move forward with processing the image but printing a larger size may distort the image. You will not be able to return the product after choosing this option.
              </div>
              <label slot="reference" class="label" v-if="option.isSize && option.isLowRes">⚠️ Low resolution</label>
            </popper>

            <span class="info-icon" v-if="option.isMaterial"><icon-info /></span>
          </div><!-- /.column -->
        </div><!-- /.row -->
      </div><!-- /.flex-container -->
    </div><!-- /.step-body -->
  </div><!-- /.radio-options -->
</template>

<script>
import Popper from 'vue-popperjs'
import { mapActions, mapState } from "vuex"
import { validateRadioOptions } from "@/helpers/validation"
import 'vue-popperjs/dist/vue-popper.css'

export default {
  name: "RadioOptions",
  components: {
    Popper
  },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    unlocked: {
      type: Boolean,
      required: true
    },
    optionGroup: {
      type: Object,
      required: true,
      validator: function(value) {
        return validateRadioOptions(value)
      }
    }
  },
  data: function() {
    return {
      optionCodeSelected: null
    };
  },
  methods: {
    ...mapActions(["setSelectedOptions", "setActiveGroup", "setDeactiveGroup"]),
    selectOption(option) {
      // Return if image is not exist
      if (!this.selectedPhoto) return;

      // Checking to make sure it isn't an invalid size and that it isn't already selected
      // And make sure that the size is actually selected on the state, not just in this component (When a size is invalid after a new photo is uploaded, it is deselected)
      if (
        !(
          (option.isSize && !option.isValid) ||
          (this.optionCodeSelected == option.optionCode &&
            this.selectedOptions[option.groupCode].selected)
        )
      ) {
        this.optionCodeSelected = option.optionCode;
        this.setSelectedOptions({
          var: this.optionGroup.code,
          val: {
            ...option,
            selected: true,
          },
        })
      }
    },
    setActive() {
      if (this.unlocked) {
        if (this.active) {
          this.setDeactiveGroup()
        }
        else {
          this.setActiveGroup(this.optionGroup)
        }
      }
    }
  },
  computed: {
    ...mapState([
      "selectedPhoto",
      "selectedOptions",
      "selectedSize",
      "initialBind",
      "currentCroppieImage",
    ]),
    sizeWarn() {
      // If options are sizes, and you have a size selected, and you have made edits to your arranger
      return !!(
        this.selectedSize &&
        this.initialBind != this.currentCroppieImage &&
        this.optionGroup.options.find(option => option.isSize)
      );
    }
  }
}
</script>
